<template>
  <div>
    <forgot-password-form />
  </div>
</template>

<script>
import forgotPasswordForm from "../components/login/ForgotPasswordForm";

export default {
  components: {
    forgotPasswordForm
  }
};
</script>
